<template>
  <div class="wrapBox">
    <div class="top">
      <el-button type="primary" @click.native="goback">返回</el-button>
    </div>
    <div class="son-wrap">
      <el-aside width="300px" style="height: auto">
        <el-row class="title" :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple">部门列表</div>
          </el-col>
        </el-row>
        <div>
          <div class="custom-tree-container">
            <div class="block">
              <el-tree
                :data="deptTreeData"
                node-key="id"
                @node-click="deptClick"
                ref="tree"
                default-expand-all
                highlight-current
                :expand-on-click-node="false"
              >
                <span class="custom-tree-node is-show" slot-scope="{ node }">
                  <span>{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </div>
        </div>
      </el-aside>
      <el-container style="flex-direction: column">
        <el-row class="title" :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple">固定资产折旧表</div>
          </el-col>
        </el-row>
        <div class="son-box">
          <el-form
            size="medium"
            :inline="true"
            :model="queryForm"
            ref="queryForm"
            class="input-form-inline"
            @submit.native.prevent
          >
            <div>
              <el-form-item prop="buyDate">
                <el-date-picker
                  v-model="queryForm.buyDate"
                  format="yyyy年MM月"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择购车日期"
                  type="month"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item class="r-10" prop="plateNum">
                <el-input
                  v-model="queryForm.plateNum"
                  @keyup.enter.native="query"
                  placeholder="车牌号"
                ></el-input>
              </el-form-item>
              <el-form-item class="r-10" prop="name">
                <el-input
                  v-model="queryForm.name"
                  @keyup.enter.native="query"
                  placeholder="车辆绑定人"
                ></el-input>
              </el-form-item>
              <el-button
                v-if="hasPerm('base:station:list')"
                type="primary"
                @click="query"
                >查询</el-button
              >
              <el-button v-if="hasPerm('base:station:list')" @click="reset"
                >取消</el-button
              >
            </div>

            <div style="margin-bottom: 20px">
              <el-button
                v-if="hasPerm('base:station:import')"
                type="primary"
                class="btn-width"
                @click="exportFile"
                >导出</el-button
              >
            </div>
          </el-form>
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            max-height="590"
            size="mini"
            row-key="vehicleId"
            border
            default-expand-all
            :tree-props="{ children: 'children' }"
          >
            <el-table-column
              prop="label"
              label="使用部门"
              align="center"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="plateNum"
              width="90"
              label="车牌号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="name"
              width="90"
              align="center"
              label="车辆绑定人"
            ></el-table-column>
            <el-table-column
              prop="companyName"
              align="center"
              label="所属运维公司"
            ></el-table-column>
            <el-table-column
              prop="buyTime"
              align="center"
              label="购入日期"
            ></el-table-column>
            <el-table-column
              prop="originalPrice"
              width="90"
              align="center"
              label="原值（元）"
            ></el-table-column>
            <el-table-column
              prop="depreciationRate"
              width="80"
              align="center"
              label="残值率"
            ></el-table-column>
            <el-table-column
              prop="depreciationYears"
              width="80"
              align="center"
              label="折旧年限"
            ></el-table-column>
            <el-table-column
              prop="discountMonth"
              width="100"
              align="center"
              label="本月折旧（元）"
            ></el-table-column>
            <el-table-column
              prop="discountYear"
              width="100"
              align="center"
              label="本年折旧（元）"
            ></el-table-column>
            <el-table-column
              prop="discountSum"
              width="100"
              align="center"
              label="累计折旧（元）"
            ></el-table-column>
            <el-table-column
              prop="netWorth"
              width="80"
              align="center"
              label="净值（元）"
            ></el-table-column>
          </el-table>
          <!-- <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="limit"
            layout="total, prev, pager, next, jumper"
            :total="total"
          ></el-pagination> -->
        </div>
      </el-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "Depreciation",
  data() {
    return {
      deptTreeData: [],
      gpsTypeList: [],
      queryForm: {
        buyDate: "",
        plateNum: "",
        name: "",
        deptId: "",
      },
      tableData: [],
    }
  },
  created() {
    this.getDeptList()
  },
  watch: {
    deptTreeData(val) {
      let _this = this
      if (val) {
        this.show = true
        this.$nextTick(() => {
          if (_this.queryForm.deptId == "") {
            document.querySelector(".el-tree-node__content").click()
          } else {
            _this.$refs.tree.setCurrentKey(_this.queryForm.deptId)
            _this.getDepreciationList()
          }
        })
      }
    },
  },
  methods: {
    // 文件导出
    exportFile() {
      let _this = this
      let url =
        "/api/outlay/manage/fixedAssetsDep/export?deptId=" +
        _this.queryForm.deptId +
        "&buyDate=" +
        _this.queryForm.buyDate +
        "&plateNum=" +
        _this.queryForm.plateNum +
        "&name=" +
        _this.queryForm.name
      window.location.href = url
    },
    // 获取固定资产折旧表
    async getDepreciationList() {
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/outlay/manage/fixedAssetsDep",
        {
          params: _this.queryForm,
        }
      )
      if (res.code == 1) {
        _this.tableData = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    goback() {
      this.$emit("goback")
    },
    async getDeptList() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/sys/dept/list")
      if (res.code == 1) {
        if (res.data.length == 0) {
          _this.queryForm.deptId = ""
        }
        _this.deptTreeData = res.data
        _this.getDepreciationList()
      } else {
        _this.queryForm.deptId = ""
        _this.$message.warning(res.msg)
      }
    },
    deptClick(deptDatas) {
      this.queryForm.deptId = deptDatas.id
      this.getDepreciationList()
    },
    query() {
      this.getDepreciationList()
    },
    reset() {
      this.$resetForm(this, "queryForm")
      this.getDepreciationList()
    },
  },
}
</script>

<style lang="scss" scoped>
.son-wrap {
  display: flex;
  flex-direction: row;
  height: calc(100% - 42px);
}
.son-wrap .el-container {
  background-color: #fff;
  height: 100%;
}
.son-box {
  padding: 0 20px;
}
.wrapBox {
  width: 100%;
  height: calc(100% - 20px);
}
.top {
  margin-bottom: 10px;
}
/deep/ .el-table td,
/deep/ .el-table th.is-leaf {
  border: 1px solid #ebeef5;
}
/deep/ .el-table td,
/deep/ .el-table--mini th {
  padding: 6px 0px;
}
/deep/ .el-table--border,
.el-table--group {
  border: none;
}
/deep/ .el-table--border::after,
/deep/ .el-table--group::after {
  height: fit-content;
}
</style>
